import { render, staticRenderFns } from "./LiveOrders.vue?vue&type=template&id=74dec3aa&"
import script from "./LiveOrders.vue?vue&type=script&lang=js&"
export * from "./LiveOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports